import { useEffect, useState } from 'react';
import { geneticsApi } from '../../api/genetics';

interface TestBreedingHintProps {
  birdId: string;
  locusId: string;
}

export default function TestBreedingHint({ birdId, locusId }: TestBreedingHintProps) {
  const [guide, setGuide] = useState<Awaited<ReturnType<typeof geneticsApi.getTestBreedingGuide>> | null>(
    null,
  );

  useEffect(() => {
    geneticsApi
      .getTestBreedingGuide(birdId, locusId)
      .then(setGuide)
      .catch(() => setGuide(null));
  }, [birdId, locusId]);

  if (!guide?.applicable) return null;

  return (
    <div className="mt-2 rounded border border-amber-200 bg-amber-50 p-2 text-xs text-amber-950">
      <p className="font-medium">Test breeding — confirm split male</p>
      <p className="mt-1">
        Mate to a <span className="font-medium">{guide.testMateDescription}</span>
        {guide.maleGenotype ? ` (current: ${guide.maleGenotype})` : null}.
      </p>
      {guide.expectedOutcomes?.length ? (
        <ul className="mt-1 list-disc list-inside space-y-0.5">
          {guide.expectedOutcomes.map((outcome) => (
            <li key={`${outcome.genotype}-${outcome.sex}`}>
              {outcome.phenotype} — {Math.round(outcome.probability * 100)}%
              {outcome.sex !== 'EITHER' ? ` (${outcome.sex.toLowerCase()})` : ''}
            </li>
          ))}
        </ul>
      ) : null}
      {guide.interpretation ? <p className="mt-1 text-amber-900">{guide.interpretation}</p> : null}
    </div>
  );
}
